export default __webpack_public_path__ + "static/media/clicktool_dashboard.bb05c823.mp4";